import 'jquery';
import 'bootstrap/dist/js/bootstrap';

const services = {}
window.services = services;

// Azure QA settings
//services.webAPIUrl = 'https://qamy.showerdoorinstallation.com/';   //Azure API URL
//services.homeDepotAPIUrl = 'https://api.homedepot.com/v3/catalog/';
//services.homeDepotAPIKey = 'Fs9kUsaROH6WUphbU4BYo1PfkC5YhQGh';
//services.touchWebServicesURL = 'https://secure2.homedepot.com/mcc-cart/v2/Cart';
//services.viewCartUrl = 'https://www.homedepot.com/mycart/home';
//services.storeRedirectUrl = 'https://qamy.showerdoorinstallation.com/desktop/WhereToBuy.html';
//services.revisionRedirectUrl = 'https://qamy.showerdoorinstallation.com/desktop/ViewDesign.htm';
////general settings
//services.mobileCartUrl = 'https://www.homedepot.com/OnlineCheckout/servlet/THDMobileOrderItemAdd';
//services.mobileCartRedirectUrl = 'https://www.homedepot.com/mycart/home';

//// Smallfootprint.net QA
//services.webAPIUrl = 'https://showerdoorinstallation.smallfootprint.net/'; //RackSpace API URL
//services.homeDepotAPIUrl = 'https://api.homedepot.com/v3/catalog/'; //QA sandbox key
//services.homeDepotAPIKey = 'Fs9kUsaROH6WUphbU4BYo1PfkC5YhQGh'; //QA sandbox key
//services.storeRedirectUrl = 'http://homedepot.smallfootprint.net/desktop/WhereToBuy.html';
//services.revisionRedirectUrl = 'https://delta-iframe.smallfootprint.net/configure/ViewDesign.aspx';
//services.touchWebServicesURL = 'https://secure2.homedepot.com/mcc-cart/v2/Cart';
//services.viewCartUrl = 'https://www.homedepot.com/mycart/home';

// Live 
services.webAPIUrl = 'https://my.showerdoorinstallation.com/';   //Azure API URL
services.homeDepotAPIUrl = 'https://api.homedepot.com/v3/catalog/';
services.homeDepotAPIKey = 'Fs9kUsaROH6WUphbU4BYo1PfkC5YhQGh';
services.touchWebServicesURL = 'https://secure2.homedepot.com/mcc-cart/v2/Cart';
services.viewCartUrl = 'https://www.homedepot.com/mycart/home';
services.storeRedirectUrl = 'https://my.showerdoorinstallation.com/desktop/WhereToBuy.html';
services.revisionRedirectUrl = 'https://my.showerdoorinstallation.com/desktop/ViewDesign.htm';
//general settings
services.mobileCartUrl = 'https://www.homedepot.com/OnlineCheckout/servlet/THDMobileOrderItemAdd';
services.mobileCartRedirectUrl = 'https://www.homedepot.com/mycart/home';







services.addItemsToCart = function (cartItems, successCallback) {

    var request = {
        CartRequest: {
            itemDetails: []
        }
    }

    if (cartItems) {
        if (cartItems.length > 0) {
            $.each(cartItems, function (indexItem, cartAddItem) {
                request.CartRequest.itemDetails.push({ itemId: cartAddItem, quantity: 1, fulfillmentLocation: "DirectShip", fulfillmentMethod: "ShipToHome" });
            });
        }
    }

    $.ajax({
        type: 'POST',
        url: services.touchWebServicesURL,
        data: JSON.stringify(request),
        contentType: 'application/json',
        accept: 'application/json; charset=utf-8',
        dataType: 'json',     
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            var cartModel = data.CartModel;
            var errormessages = '';
            if (cartModel) {
                if (cartModel.errorModel && cartModel.errorModel.length > 0) {
                    $.each(cartModel.errorModel, function (index, err) {
                        errormessages = errormessages + err.description + '\r\n';
                        $('#loadingOverlay').hide();
                        alert(errormessages);
                    });
                }
                else
                    if (successCallback != undefined) successCallback(data);
            }

        },
        error: function (xhr, ajaxOptions, thrownError) {
            alert('services.addItemsToCart ajax error: ' + thrownError);
            console.log('services.addItemsToCart ajax error: ' + thrownError);
            $('#loadingOverlay').hide();
        }
    });
}


services.getDoorTypes = function (successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/doorTypes',
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getDoorTypes ajax error: ' + thrownError);
        }
    });
}
services.getDoorSizeRanges = function (doorTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/doorSizes',
        data: { DoorType: doorTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getDoorSizeRanges ajax error: ' + thrownError);
        }
    });
}
services.getDoorSize = function (doorSizeId, finishTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/doorSizes',
        data: { Id: doorSizeId, FinishType: finishTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getDoorSize ajax error: ' + thrownError);
        }
    });
}
services.getSideLinks = function (stepNumber, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/sidelinks',
        data: { stepNumber: stepNumber },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getSideLinks ajax error: ' + thrownError);
        }
    });
}
services.getRelatedItems = function (handleProductNumber, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/relateditems',
        data: { Handle: handleProductNumber },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getRelatedItems ajax error: ' + thrownError);
        }
    });
}
services.getOMSID = function (trackProductNumber, glassProductNumber, barProductNumber, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/finishes',
        data: { trackNo: trackProductNumber, glassNo: glassProductNumber, handleNo: barProductNumber },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getOMSID ajax error: ' + thrownError);
        }
    });
}
services.sendEmail = function (formData, successCallback) {
    $.ajax({
        url: services.webAPIUrl + 'Util/Send',
        data: formData,
        type: 'POST',
        success: function (result) {
            //successCallback(result);
            console.log(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log("services.sendEmail ajax error: " + thrownError);
            alert('Unable to send e-mail. Contact the site administrator if the problem persists!');
        }
    });

    successCallback();
}

// items { itemId, price }
services.getPrices = function (items, successCallback) {
    var itemIds = items.map(function (e) { return e.itemId; });

    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        timeout: 1500,
        url: services.homeDepotAPIUrl + 'products/sku',
        data: { itemId: itemIds.join(), key: services.homeDepotAPIKey, show: 'pricing' },
        success: function (result) {
            var source = [];
            if (!$.isArray(result.products.product)) {
                source.push(result.products.product);
            }
            else {
                source = result.products.product;
            }
            var filteredResult = source.map(function (e) {
                return {
                    id: e.defaultSku,
                    price: e.skus.sku.storeSkus.storeSku.pricing == undefined ? parseFloat(items.filter(function (el) { return el.itemId == e.defaultSku; })[0].price) : e.skus.sku.storeSkus.storeSku.pricing.originalPrice
                };
            });
            if (items.length > source.length) {
                $.each(items, function (i, i1) {
                    var found = false;
                    $.each(source, function (j, i2) {
                        if (i1.itemId == i2.defaultSku.toString()) { found = true; return false; }
                    });
                    if (!found) filteredResult.push({ id: i1.itemId, price: parseFloat(i1.price) });
                });
            }
            successCallback(filteredResult);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            //fallback when HD api is not working
            successCallback(items.map(function (e) { return { id: e.itemId, price: parseFloat(e.price) }; }));
            console.log('services.getPrices ajax error: ' + thrownError);
        }
    });
}
services.getPrice = function (itemId, price, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        timeout: 1500,
        url: services.homeDepotAPIUrl + 'products/sku',
        data: { itemId: itemId, key: services.homeDepotAPIKey, show: 'pricing' },
        success: function (result) {
            var filteredResult = {
                id: result.products.product.defaultSku,
                price: result.products.product.skus.sku.storeSkus.storeSku.pricing == undefined ? parseFloat(price) : result.products.product.skus.sku.storeSkus.storeSku.pricing.originalPrice
            };
            successCallback(filteredResult);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            //fallback when HD api is not working
            successCallback({ id: itemId, price: parseFloat(price) });
            console.log('services.getPrices ajax error: ' + thrownError);
        }
    });
}

services.getInvalidStores = function (successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/invalidstores',
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getInvalidStores ajax error: ' + thrownError);
        }
    });
}
services.getStores = function (latitude, longitude, distance, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/stores',
        data: { lat: latitude, lon: longitude, dist: distance },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getStores ajax error: ' + thrownError);
        }
    });
}
services.updateStoreLocation = function (storeId, latitude, longitude) {
    $.ajax({
        type: 'PUT',
        url: services.webAPIUrl + 'api/stores/' + storeId,
        data: { latitude: latitude, longitude: longitude },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.setStores ajax error: ' + thrownError);
        }
    });
}

services.getGlasses = function (doorSizeId, finishTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/glasses',
        data: { DoorSize: doorSizeId, FinishType: finishTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getGlasses ajax error: ' + thrownError);
        }
    });
}
services.getGlass = function (productNumber, finishTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/glasses',
        data: { productNumber: productNumber, finishtype: finishTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getGlass ajax error: ' + thrownError);
        }
    });
}

services.getTracks = function (doorSizeId, GlassProductNo, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/finishes',
        data: { doorType: doorSizeId, GlassProductNo: GlassProductNo },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getTracks ajax error: ' + thrownError);
        }
    });
}
services.getTrack = function (productNumber, doorSize, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/finishes',
        data: { productNumber: productNumber, doorSize: doorSize, comment: 'nothing' },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getTrack ajax error: ' + thrownError);
        }
    });
}

services.getBars = function (trackTypeId, glassTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/handles',
        data: { FinishProductNumber: trackTypeId, GlassProductNumber: glassTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getBars ajax error: ' + thrownError);
        }
    });
}
services.getBar = function (barProductNumber, trackProductNumber, glassProductNumber, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/handles',
        data: { handleProductNumber: barProductNumber, trackProductNumber: trackProductNumber, glassProductNumber: glassProductNumber },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getBar ajax error: ' + thrownError);
        }
    });
}

services.addItemToMobileCart = function (omsid, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: "GET",
        dataType: "json",
        url: services.mobileCartUrl,
        data: { itemType: 'DirectShip', catEntryId: omsid, quantity: 1, addToCartConfirmation: true, addToCartCallback: services.addedToCart },
        complete: function (result) {
            if (successCallback != undefined) successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.addItemToMobileCart ajax error: ' + thrownError);
        }
    });
}
services.addAllToMobileCart = function (glassProductNumber, trackProductNumber, barProductNumber, relatedItems, successCallback) {
    var cartItemsToService = [];
    services.getOMSID(trackProductNumber, glassProductNumber, barProductNumber, function (data) {
        if (data.OMSID == undefined) {
            cartItemsToService.push(data.FinishOnlineNumber);
            cartItemsToService.push(data.GlassOnlineNumber);
            cartItemsToService.push(data.HandleOnlineNumber);
        } else {
            cartItemsToService.push(data.OMSID);
        }

        for (var i = 0; i < relatedItems.length; i++) services.addItemToMobileCart(relatedItems[i]);

        successCallback();
    });
    for (var i = 0; i < relatedItems.length; i++) {
        if (relatedItems[i].length > 0)
            cartItemsToService.push(relatedItems[i]);
    }
    services.addItemsToCart(cartItemsToService, function (data) {
        setTimeout(function () {
            window.location = services.mobileCartRedirectUrl;
        }, 2000);
    });

}
services.addedToCart = function (e) {
    console.log('services.addedToCart called: ' + e);
}

services.subscribeEmailAddress = function (emailAddress, firstName, successCallback) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: services.webAPIUrl + 'Util/SubscribeEmail',
        data: { email: emailAddress, name: firstName },
        success: function (result) {
            if (successCallback != undefined) successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.subscribeEmailAddress ajax error: ' + thrownError);
        }
    });
}

services.AddShopingCartReport = function (type, glass, finish, handle, related,accessories, source, ipAddress) {
    $.ajax({
        url: services.webAPIUrl + 'Util/SaveCart',
        data: {
            type: type,
            source: source,
            glass: glass,
            finish: finish,
            handle: handle,
            related: related,
            accessories: accessories,
            ipAddress: ipAddress
        },
        method: 'GET',
        beforeSend: function (xhr) {
            xhr.withCredentials = true;
        },
        success: function (result) {
            console.log('Shopping cart saved. ');
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError);
        }
    });
}

services.downloadPdf = function (data, successCallback) {
    $.ajax({
        url: services.webAPIUrl + 'Util/Pdf',
        data: { data: data },
        type: 'POST',
        success: function (result, response, test) {
            successCallback(services.webAPIUrl + 'Util/GetFile?path=' + result.file);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log("services.sendEmail ajax error: " + thrownError);
            return false;
        }
    });
    //moved here so it shows up on UI instantly. The email will be queued for sending but we don't need to wait for confirmation.
}

services.showSideLinks = function (address) {
    $("#sideLinksModal .modal-content").load(address, function (response, status, xhr) {
        if (status == "error") {
            $("#sideLinksModal").empty();
        } else {
            $("#sideLinksModal").modal("show");
        }
    });
}

services.drawSideLinks = function (stepNumber) {
    services.getSideLinks(stepNumber, function (data) {
        $('div#sideLinks').empty();

        for (var i = 0; i < data.length; i++) {
            $('div#sideLinks').append($('<div onclick="services.showSideLinks(\'' + data[i].ContentAddress + '\')"><span class="glyphicon glyphicon-ok"></span> ' + data[i].Title + '</div>'));
        }
    });
}

services.clearSideLinksDialog = function () {
    $("#sideLinksModal .modal-content").empty();
}

services.showAditionalInformation = function (address) {
    $("#aditionalInformationModal .modal-content").load(address, function (response, status, xhr) {
        if (status == "error") {
            $("#aditionalInformationModal").empty();
        } else {
            $("#aditionalInformationModal").modal("show");
        }
    });
}


services.clearAditionalInformationDialog = function () {
    $("#aditionalInformationModal .modal-content").empty();
}

services.getHooksAndKnobs = function (finishTypeId, handleName,doorTypeId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/accessories',
        data: { finishTypeId: finishTypeId, handleName: handleName, doorTypeId: doorTypeId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getHooksAndKnobs ajax error: ' + thrownError);
        }
    });
}

services.getAccessory = function (accessoryId, successCallback) {
    $.ajax({
        beforeSend: function (req) { req.setRequestHeader("Accept", "text/json"); },
        type: 'GET',
        dataType: "json",
        url: services.webAPIUrl + 'api/accessories',
        data: { accessoryId: accessoryId },
        success: function (result) {
            successCallback(result);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log('services.getGlass ajax error: ' + thrownError);
        }
    });
}

var helpers = {};


helpers.setHardwareTitle = function (doorType) {
    var title = " Handle";
    if (doorType == 4 || doorType == 5) {
        title = " Knob";
    }
    // set the value
    $("#hardwareTitle").text(title);
    var miniCartTitle = $("div.hardware .cartTopTitle");
    if (miniCartTitle) {
        $(miniCartTitle).text(title);
    }
}

export { services, helpers };


// WEBPACK FOOTER //
// ./Common/js/services.js